import axios from "axios";
import { API_BASE_URL, buildHeaders } from "utils/services";

// Grille des frais en vigueur, lue dans le fees-manager (via l'API admin)
export const fetchFeesSchedule = async (user) => {
    try {
        const { data } = await axios.get(`${API_BASE_URL}/fees/schedule`, buildHeaders(user));
        return data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

// Simulation : le fees-manager calcule les frais avec les vrais handlers, pour un profil client simulé
// et, si `overrides` n'est pas vide, avec la grille modifiée. Résultat : [{ current, simulated }] par payload.
export const simulateFees = async (user, type, payloads, overrides, profile) => {
    try {
        const { data } = await axios.post(`${API_BASE_URL}/fees/simulate/${type}`,
            { payloads, overrides, profile }, buildHeaders(user));
        return data.results;
    } catch (error) {
        console.error(error);
        throw error;
    }
}
